/** Leaving presentation (a report's preview) from places keys cannot leave, such as an HTML page's frame. */
export const PRESENTATION_EXIT_EVENT = 'unity-presentation-exit';

export const requestPresentationExit = (): void => {
    window.dispatchEvent(new Event(PRESENTATION_EXIT_EVENT));
};
